import {useContext, useEffect, useState, useCallback} from 'react';
import {useParams} from 'react-router';
import {useNavigate} from "react-router-dom";
import {UserContext} from '../../context/UserContext';
import {OrderContext} from "../../context/OrderContext";
import { APIGetTenderByOrderId } from '../../api/orders/OrdersTender';
import {APIGetOrder, APISaveOrder} from "../../api/orders/Orders";
import {TranslateOrderStatus} from "../../helper/orderStageHandler";
import {LoadingIndicator} from '../../components/loadingIndicator/loadingIndicator';
import OrderInTender from '../../components/orderElements/orderInTender';
import OrderInReview from '../../components/orderElements/orderInReview';
import OrderAddBid from '../../components/orderElements/orderAddBid';
import OrderCommunication from "../../components/orderElements/orderCommunication";
import OrderApplication from '../../components/orderElements/orderApplication';
import {OrderActions } from '../../components/orderElements/orderActions';
import OrderInReviewCreator from "../../components/orderElements/orderInReviewCreator";
import OrderBidModal from '../../components/dialogs/startTender';
import StartReview from "../../components/dialogs/startReview";
import { NewOrderModal } from '#src/components/dialogs/newOrderModal.jsx';
import {Page404} from '../Page-404';
import {HiChevronLeft} from "react-icons/hi2";



export const Order = () => {
    const { user, company } = useContext(UserContext);
    const {id} = useParams();

    const [order, setOrder] = useState(null);
    const [tender, setTender] = useState(null);
    const [userStatus, setUserStatus] = useState(null);
    const [orderEdit,setOrderEdit] = useState(false);
    const [openAddContact, setOpenAddContact] = useState(false);
    const [showBidModal,setShowBidModal] = useState(false);
    const [openOrderStartReviewModal, setOpenOrderStartReviewModal] = useState(false);
    const [openContractTender, setOpenContractTender] = useState(false);

    const navigate = useNavigate();

    const getOrder = useCallback(async () => {
        const orderObject = await APIGetOrder({companyId: user.companyId, id});
        setOrder(orderObject);
        return orderObject;
    }, [id, user.companyId]);

    const saveOrder = async (stage) => {
        const updatedOrder = {...order, stage,}
        await APISaveOrder({order: updatedOrder, companyId: user.companyId});
        setOrder(updatedOrder);
        setOrderEdit(false);
    }

    const getCommunication = () => {

        if (order?.stage !== 'draft') {
            if (userStatus === 'orderOwner') {
                return (<OrderCommunication />);
            }
            if (order?.stage !== 'inTender') {
                return (<OrderCommunication />);
            }
        }
        return null;
    }

    const getAddBidForm = () => {

        if (order?.stage === "inTender" || order?.stage === "offered") {
            return (<OrderAddBid/>);
        }
        return null;
    }

    const getOrderInReviewCreator = () => {

        if (order?.stage === "inDevelopment" || order?.stage === "inReview" || order?.stage === "completed") {
            return (<OrderInReviewCreator/>);
        }
        return null;
    }

    const getOrderInTender = () => {
        if (order.stage === "inTender") {
            return (<OrderInTender/>);
        }
        return null;
    }

    const getOrderInReview = () => {

        if (order.stage === "inReview" || order.stage === "completed" || order.stage === "inDevelopment") {
            return (<OrderInReview/>);
        }
        return null
    }

    useEffect(() => {
        const getUserStatus = async () => {
            const companyStatus = order.companyStatus;
                if (company.permissions?.planCreation && companyStatus === 'viewer') {
                    setUserStatus('creator');
                } else {
                    setUserStatus(companyStatus);
                }
                return;
        }

        const getTender = async () => {
            const tenderObject = await APIGetTenderByOrderId({orderId: id, companyId: user.companyId});
            if (tenderObject) {
                setTender(tenderObject?.rows?.[0]);
            }
        }

        if (order) {
            getUserStatus();
        } else {
            getOrder();
            getTender();
        }
    }, [company.permissions?.planCreation, company.type, getOrder, id, order, user.companyId]);

    if (!userStatus) {
        return (
            <div className='flex w-full h-dvh justify-center items-center'>
                <LoadingIndicator/>
            </div>
        );
    } 

    if (userStatus === 'none' && order.stage !== 'inTender') {
        return (<Page404/>);
    }

    return (
        <div className={"mx-auto xl:max-w-7xl orderDetails px-2 lg:px-6"}>
            <main>
                <div className="w-full">
                    <div className={"text-base leading-7 text-gray-600"}>
                        <OrderContext.Provider value={{
                            order,
                            tender,
                            setOrder, 
                            saveOrder,
                            getOrder,
                            orderEdit,
                            userStatus, 
                            setOrderEdit,
                            openAddContact,
                            setOpenAddContact,
                            openOrderStartReviewModal,
                            setOpenOrderStartReviewModal,
                            showBidModal,
                            setShowBidModal,
                            openContractTender,
                            setOpenContractTender,
                        }}>
                            {order.stage === 'draft' && (
                                <NewOrderModal
                                    openNewOrderModal={orderEdit}
                                    setOpenNewOrderModal={setOrderEdit}
                                />
                            )}
                            <div className={"text-base mt-5 mb-4 md:mb-6 leading-7 text-gray-600"}>
                                <div className="md:flex md:items-center md:justify-between">
                                    <div className="md:flex justify-between flex-1">
                                        <div className="flex">
                                            <button onClick={() => {
                                                if (order.companyStatus === 'tenderOwner') {
                                                    navigate('/ordersManagement/')
                                                } else if (order.companyStatus === 'viewer') {
                                                    navigate('/ordersTender/')
                                                } else {
                                                    navigate('/orders/')
                                                }
                                                }}>
                                                <HiChevronLeft  className={"text-3xl  block sm:flex  cursor-pointer"} />
                                            </button>
                                            <h2 className="text-xl block truncate inline flex-grow sm:w-full font-semibold  leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                                                <div className={"ml-2 truncate"}>Auftrag: {order?.planId}</div>
                                                <div className={"ml-2 text-base font-medium text-gray-550"}>{"Fortschritt: " +TranslateOrderStatus(order?.stage).label}</div>
                                            </h2>
                                        </div>
                                        <OrderActions/>
                                    </div>
                                </div>
                            </div>
                            <div className={"block lg:flex"}>
                                <div className={"w-full lg:w-2/3 lg:pr-4"}>
                                    {(userStatus === 'tenderOwner') && getOrderInReviewCreator()}
                                    {(userStatus === 'orderOwner') && getOrderInReview()}
                                    {(userStatus === 'orderOwner') && getOrderInTender()}
                                    <OrderApplication/>
                                </div>
                                <div className={"w-full lg:pl-4 lg:w-1/3"}>
                                    {( userStatus !== 'orderOwner' && userStatus !== 'viewer' ) && getAddBidForm()}
                                    {getCommunication()}
                                    {(userStatus === 'tenderOwner') &&  (<StartReview/>)}
                                </div>
                            </div>
                            {userStatus === 'orderOwner' &&  (<OrderBidModal/>)}
                        </OrderContext.Provider>
                    </div>
                </div>
            </main>
        </div>
    );
};
